import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/microsoft.png'


const _hoisted_1 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  alt: "microsoft-logo",
  class: "mx-3"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "mr-3" }, "Microsoftでログイン", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("button", {
    class: "microsoft-button",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.click && _ctx.click(...args)))
  }, [
    _hoisted_1,
    _hoisted_2
  ]))
}